/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Skill_GInputs */

const en_mk_tut_skill_g = /** @type {(inputs: Mk_Tut_Skill_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When a way of working is always the same — a report format, the order for handling a complaint — write it as a Skill so every agent uses it.`)
};

const id_mk_tut_skill_g = /** @type {(inputs: Mk_Tut_Skill_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau ada cara kerja yang selalu sama — format laporan, urutan menangani komplain — tuliskan sebagai Skill supaya setiap agen memakainya.`)
};

/**
* | output |
* | --- |
* | "When a way of working is always the same — a report format, the order for handling a complaint — write it as a Skill so every agent uses it." |
*
* @param {Mk_Tut_Skill_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_skill_g = /** @type {((inputs?: Mk_Tut_Skill_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Skill_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_skill_g(inputs)
	return en_mk_tut_skill_g(inputs)
});